export default {
  input: {
    fontSize: 16,
    padding: '12px 0 10px',
  },
};
